import React, {FC} from 'react';
import {View} from 'react-native';
import {COLOR, Icon} from '@lookiero/aurora';
import {style} from './StepIndicator.style';
import {StepVariant} from '../StepVariant';

interface StepIndicatorProps {
  readonly variant: StepVariant;
}

export const StepIndicator: FC<StepIndicatorProps> = ({variant}) => (
  <View style={style.stepIndicatorOutline}>
    <View style={[style.stepIndicator, style[`stepIndicator_${variant}`]]}>
      {variant === StepVariant.CHECKED && <Icon name="tick" testID="checked-icon" color={COLOR.BG_BASE} />}
    </View>
  </View>
);
